import { SvgIcon, SvgIconProps } from '@mui/material'

export default (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 3.5H4C2.9 3.5 2 4.4 2 5.5V19.5C2 20.6 2.9 21.5 4 21.5H20C21.1 21.5 22 20.6 22 19.5V5.5C22 4.4 21.1 3.5 20 3.5ZM20 19.5H4V5.5H20V19.5Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.41 10.92L17.99 9.5L14.82 12.67L13.41 11.25L12 12.66L14.82 15.5L19.41 10.92ZM5 7.5H10V9.5H5V7.5ZM5 11.5H10V13.5H5V11.5ZM5 15.5H10V17.5H5V15.5Z'
    />
  </SvgIcon>
)
